import TypesController from './TypesController';

export default TypesController;
